import React, {PureComponent} from "react"
import styled from "styled-components"

interface StyledProps {
  isSet?: boolean,
  size?: string,
  src: string
}

interface Props {
  isSet?: boolean,
  size?: string,
  src: string
}

const StyledImg = styled<StyledProps, "div">("div")`
  ${({size}: StyledProps) => `
    border-radius: ${size};
    height: ${size};
    min-height: ${size};
    min-width: ${size};
    width: ${size};
  `}
  ${({src}) => `background-image: url(${src});`}
  ${({isSet}) => (isSet ? "opacity: 1;" : "opacity: 0.3;")}
  background-position: center center;
  background-repeat: no-repeat;
  background-size: cover;
`

class Trophy extends PureComponent<Props> {
  static defaultProps = {
    isSet: true,
    size: "90px"
  }

  render() {
    const {isSet, size, src} = this.props
    return <StyledImg isSet={isSet} size={size} src={src} />
  }
}

export default Trophy
